import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";
import SupportTickets from "@/components/SupportTickets";

export default function SupportPage() {
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const [tickets, setTickets] = useState([]);

  const fetchTickets = async () => {
    try {
      const r = await axios.get(`${API}/support/tickets`);
      setTickets(r.data || []);
    } catch {
      // silent
    }
  };

  useEffect(() => { if (token) fetchTickets(); }, [token]);

  if (!token) {
    return <Navigate to="/auth?next=/support" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white text-black">
      <SiteHeader />
      <main className="flex-1 pt-24 pb-12">
        <div className="container mx-auto max-w-5xl px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Поддержка</h1>
          <SupportTickets tickets={tickets} onTicketsUpdate={fetchTickets} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
